import { render } from "./product_create.vue?vue&type=template&id=0360d14a"
import script from "./product_create.vue?vue&type=script&lang=js"
export * from "./product_create.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__